import {inject, Injectable, signal} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export interface ConfirmOptions {
  message: string;
  title: string;
  accept: () => void;
  reject?: () => void;
}

@Injectable({providedIn: 'root'})
export class ConfirmService {

  translateService = inject(TranslateService);
  // A améliorer car je ne suis pas censé avoir accès à visible de l'extérieur.
  // Faire un 2 service un pour la config du composant et un pour Usage.
  // Piste ? Délcarer le service dans le composant sans export pour ne pas se trompé à l'inject
  private _accept: (() => void) | null = null;
  private _reject: (() => void) | null = null;

  readonly visible = signal(false);
  readonly message = signal('');
  readonly title = signal('');

  confirm(options: ConfirmOptions) {
    this.message.set(options.message);
    this.title.set(this.translateService.instant(options.title));
    this._accept = options.accept;
    this._reject = options.reject ?? null;
    this.visible.set(true);
  }

  accept() {
    this._accept?.();
    this.close();
  }

  reject() {
    this._reject?.();
    this.close();
  }

  private close() {
    this.visible.set(false);
    this.message.set('');
    this._accept = null;
    this._reject = null;
  }
}
